import { useId, type ComponentProps, type ReactNode } from 'react';

import {
  Input as BaseInput,
  InputHelperText,
  InputLabel,
  InputRoot,
  InputWithCounter,
} from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';

type BaseInputProps = ComponentProps<typeof BaseInput> & {
  label?: ReactNode;
  infoIconWithTooltip?: string;
  helperText?: string | null;
};

type InputPropsWithMaxLength = BaseInputProps & {
  maxLength: number;
};

type InputPropsWithoutMaxLength = BaseInputProps & {
  maxLength?: never;
};

type InputProps = InputPropsWithMaxLength | InputPropsWithoutMaxLength;

export const Input = <T extends InputProps>({
  label,
  helperText,
  color,
  className,
  infoIconWithTooltip,
  maxLength,
  ...inputProps
}: T) => {
  const id = useId();

  // TODO: fix InputWithCounter
  const InputComponent = maxLength ? InputWithCounter : BaseInput;

  return (
    <InputRoot className={cn('w-full', className)}>
      {label && (
        <InputLabel
          htmlFor={id}
          label={label}
          infoIconWithTooltip={infoIconWithTooltip}
        />
      )}
      <InputComponent id={id} maxLength={maxLength as number} {...inputProps} />
      {helperText && <InputHelperText helperText={helperText} color={color} />}
    </InputRoot>
  );
};
